import { reactive } from "@vue/composition-api";

export function dynamicBiModel() {
  const fetchDashBoardBI = reactive({
    api: "https://dev-bcrm-ntl-api.azurewebsites.net/ntl/api/v1.0/Dashboard/BI",
    method: "POST",
    payload: {
      FromDate: "",
      ToDate: "",
    },
  });

  return {
    fetchDashBoardBI,
  };
}
